/**
 * Map theming types for customizing map appearance
 */
/**
 * Default theme values
 */
export const DEFAULT_MAP_THEME = {
    primaryColor: '#9333ea', // purple-600
    tileStyle: 'dark',
    markerStyle: 'default',
};
//# sourceMappingURL=map.js.map